import React from 'react';
import logo from '../../static/images/pswt-logo.png';

export const Logo: React.FC<React.HTMLProps<HTMLImageElement>> = ({ alt, src, style, ...rest }) => {
    return (
        <div className="logo-container">
            <img {...rest} alt={alt} src={src || logo} style={{ width: 120, height: 120, ...style }} />
        </div>
    );
};
